import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCol,
  IonImg,
  IonRow,
  IonText,
} from "@ionic/react";

import "./Testimonies.css";

// eslint-disable-next-line
export const Testimonies: React.FC<{ id?: string }> = ({ id }) => (
  <IonRow className="testimonies" id={id}>
    <IonCol size="12">
      <IonRow>
        <IonText color="marketing-gold">
          <h1 className="ion-no-padding">Testimonies</h1>
        </IonText>
      </IonRow>
      <IonRow>
        <IonText>
          Hear from our customers who rely on myFirePlane to manage their
          aircraft fleets, streamline maintenance operations, and enhance flight
          safety. These testimonials showcase how our platform delivers real
          value to aviation professionals across the industry.
        </IonText>
      </IonRow>
      <IonRow className="invisible-cards ion-justify-content-evenly">
        <IonCol size-xs="12" size-lg="4">
          <IonCard>
            <IonCardHeader>
              <IonRow className="ion-justify-content-center">
                <IonImg src="quote.svg" />
              </IonRow>
            </IonCardHeader>

            <IonCardContent>
              <IonText className="quote">
                myFirePlane is tailor made for managing a dynamic, decentralized
                fleet. This tool enables our pilots and maintenance teams to
                effectively manage maintenance and performance planning with a
                mobile device.
              </IonText>
            </IonCardContent>
            <IonRow>
              <IonText className="quote-owner">Michael</IonText>
            </IonRow>
            <IonRow className="ion-justify-content-center">
              <IonText color="marketing-gold">
                Rutledge Airborne Applications, LLC
              </IonText>
            </IonRow>
          </IonCard>
        </IonCol>
        <IonCol size-xs="12" size-lg="4">
          <IonCard>
            <IonCardHeader>
              <IonRow className="ion-justify-content-center">
                <IonImg src="quote.svg" />
              </IonRow>
            </IonCardHeader>

            <IonCardContent>
              <IonText className="quote">
                Dauntless Air was an early-stage subscriber to myFirePlane.
                Utilizing its expanding features and tools has added great value
                to our ability to track the maintenance status of our fleet of
                Fire Boss aerial firefighting aircraft, allow our pilots to
                perform real time aircraft performance calculations as well as
                conduct a pre-flight human factors review in the form of a
                Flight Risk Assessment Tool. We have integrated the flight data
                captured by myFirePlane into our company wide aircraft
                maintenance software platform, giving our aircraft maintenance
                staff real time visibility to an aircraft’s maintenance status.
                In short, mFP is a critical piece of our business model.
              </IonText>
            </IonCardContent>
            <IonRow>
              <IonText className="quote-owner">Brian Murphy</IonText>
            </IonRow>
            <IonRow className="ion-justify-content-center">
              <IonText color="marketing-gold">CFO - Dauntless Air</IonText>
            </IonRow>
          </IonCard>
        </IonCol>
        <IonCol size-xs="12" size-lg="4">
          <IonCard>
            <IonCardHeader>
              <IonRow className="ion-justify-content-center">
                <IonImg src="quote.svg" />
              </IonRow>
            </IonCardHeader>

            <IonCardContent>
              <IonText className="quote">
                myFirePlane is our pilot-friendly one stop location for
                completing performance calculations, mission flight risk
                assessments, and even tracking fleet maintenance. They are
                always responsive to our company&apos;s needs and ideas.
              </IonText>
            </IonCardContent>
            <IonRow>
              <IonText className="quote-owner">Sarah</IonText>
            </IonRow>
            <IonRow className="ion-justify-content-center">
              <IonText color="marketing-gold">Coastal Air Strike</IonText>
            </IonRow>
          </IonCard>
        </IonCol>
      </IonRow>
    </IonCol>
  </IonRow>
);
